import { call, put } from "redux-saga/effects";
import { routeConstants } from "../actions/constants/routeConstants";
import { routeService } from "../services/routesService";
import { commonActions } from "../actions/commonAction";
import { commonConstants } from "@/actions/constants/commonConstants";

function* bulkInsertRoutes(action: any): any {
    try {
        const response = yield call(routeService.bulkInsertRoutes, action.payload);
        if (response.success) {
            yield put({ type: routeConstants.bulkInsertRoutesSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message })
        } else {
            yield put({ type: routeConstants.bulkInsertRoutesFailure, payload: response.message || response.errorMessage });
            yield put(commonActions.errorResponse(response.message || "Failed to insert routes"));
        }
    } catch (error) {
        yield put({ type: routeConstants.bulkInsertRoutesFailure, payload: error });
    }   
}

function* updateRoutes(action: any): any {
    try {
        const response = yield call(routeService.updateRoutes, action.payload);
        if (response.success) {
            yield put({ type: routeConstants.updateRoutesSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message })
        } else {
            yield put({ type: routeConstants.updateRoutesFailure, payload: response.message || response.errorMessage });
            yield put(commonActions.errorResponse(response.message || "Failed to insert routes"));
        }
    } catch (error) {
        yield put({ type: routeConstants.updateRoutesFailure, payload: error });
    }   
}

export const routesSaga = {
    bulkInsertRoutes, updateRoutes
};